import { render, staticRenderFns } from "./DealDetailList.vue?vue&type=template&id=75c358fe&scoped=true&"
import script from "./DealDetailList.vue?vue&type=script&lang=js&"
export * from "./DealDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c358fe",
  null
  
)

export default component.exports